<ion-header>
  <ion-toolbar>
    <ion-button (click)="close()" fill="clear" color="white">
      <ion-icon name="close" slot="start"></ion-icon>
    </ion-button>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <ion-slides pager="true" [options]="slideOpts" #slides>
    <ion-slide *ngFor="let img of images">
      <div class="swiper-zoom-container">
        <img [src]="img">
      </div>
    </ion-slide>
  </ion-slides>
</ion-content>